export const cilPrint = ["24 24","<path d='M19.688 6.005v-5.255h-15.375v5.255c-1.988 0.105-3.56 1.741-3.563 3.745v9h3.188v-1.5h-1.688v-7.5c0.001-1.242 1.008-2.249 2.25-2.25h15c1.242 0.001 2.249 1.008 2.25 2.25v7.5h-2.063v1.5h3.563v-9c-0.002-2.004-1.575-3.64-3.553-3.745l-0.009-0zM18.188 6h-12.375v-3.75h12.375z'></path><path d='M18.563 9.375h1.5v1.5h-1.5v-1.5z'></path><path d='M20.063 13.875v-1.5h-16.5v1.5h1.875v9.375h12.75v-9.375h1.875zM16.688 21.75h-9.75v-7.875h9.75z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-print.js
// module id = null
// module chunks = 